import React from 'react';
import useTheme from '../../hooks/ui/useTheme';
import classnames from 'classnames';

interface Props {
  description: string;
  value?: string | number;
  type?: 'Error' | 'Warning' | 'Notice';
  className?: string;
}

export default function MinimumValueErrorLabel(props: Props) {
  const { description, value, type, className } = props;

  const theme = useTheme();

  const getBackgroundColor = () => {
    switch (type) {
      case 'Error':
        return theme.color.danger;
      case 'Warning':
        return theme.color.warning;
      case 'Notice':
        return theme.color.notice;
      default:
        return theme.color.danger;
    }
  };

  const getTextColor = () => {
    switch (type) {
      case 'Error':
        return theme.color.white.DEFAULT;
      case 'Warning':
      case 'Notice':
        return theme.color.black.DEFAULT;
      default:
        return theme.color.white.DEFAULT;
    }
  };

  return (
    <div className={classnames(container, className)} style={{ backgroundColor: getBackgroundColor() }}>
      <div className="flex flex-1 pr-xs">
        <p className="text-danger text-xs" style={{ color: getTextColor() }}>
          {description}
        </p>
      </div>
      {value && (
        <p className="text-danger text-xs" style={{ color: getTextColor() }}>
          {value}
        </p>
      )}
    </div>
  );
}

const container = 'flex flex-row p-xs rounded-lg justify-between bg-danger';
